var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg line-height-15 mb-8 mb-lg-16"
  }, [_vm._v(" 학력사항 ")]), _c('v-sheet', [_c('v-divider', {
    staticClass: "primary border-2"
  }), _c('vertical-table-row', {
    attrs: {
      "term": "최종학력",
      "required": _vm.mode == 'form'
    }
  }, [_vm.mode == 'form' ? [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-select', _vm._b({
    class: `institutionType-${_vm.className}`,
    attrs: {
      "label": "분류",
      "items": _vm.types,
      "menuProps": {
        attach: `.institutionType-${_vm.className}`
      }
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume.education.institutionType,
      callback: function ($$v) {
        _vm.$set(_vm.resume.education, "institutionType", $$v);
      },
      expression: "resume.education.institutionType"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "학교"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume.education.institutionName,
      callback: function ($$v) {
        _vm.$set(_vm.resume.education, "institutionName", $$v);
      },
      expression: "resume.education.institutionName"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "계열/학과"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume.education.institutionDist,
      callback: function ($$v) {
        _vm.$set(_vm.resume.education, "institutionDist", $$v);
      },
      expression: "resume.education.institutionDist"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-select', _vm._b({
    class: `attendingStatus-${_vm.className}`,
    attrs: {
      "label": "상태",
      "items": _vm.statuses,
      "menuProps": {
        attach: `.attendingStatus-${_vm.className}`
      }
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume.education.attendingStatus,
      callback: function ($$v) {
        _vm.$set(_vm.resume.education, "attendingStatus", $$v);
      },
      expression: "resume.education.attendingStatus"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-date-field', _vm._b({
    attrs: {
      "label": "입학일"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume.education.attendingStartsAt,
      callback: function ($$v) {
        _vm.$set(_vm.resume.education, "attendingStartsAt", $$v);
      },
      expression: "resume.education.attendingStartsAt"
    }
  }, 'v-date-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-date-field', _vm._b({
    attrs: {
      "label": "졸업일"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume.education.attendingEndsAt,
      callback: function ($$v) {
        _vm.$set(_vm.resume.education, "attendingEndsAt", $$v);
      },
      expression: "resume.education.attendingEndsAt"
    }
  }, 'v-date-field', _vm.attrs_input, false))], 1)], 1)] : [_c('v-row', [_c('v-col', {
    staticClass: "white-space-pre",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" " + _vm._s(_vm.makeEducationText(_vm.resume.education)) + " ")])], 1)]], 2), _vm._l(_vm.resume.education.otherEducations, function (item, index) {
    return [_c('vertical-table-row', {
      key: item.tempId,
      attrs: {
        "term": "학력사항"
      }
    }, [_vm.mode == 'form' ? [_c('v-row', {
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', [_c('v-row', {
      staticClass: "row--small"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-select', _vm._b({
      class: `institutionType-${_vm.className}-${index}`,
      attrs: {
        "label": "분류",
        "items": _vm.types,
        "menuProps": {
          attach: `.institutionType-${_vm.className}-${index}`
        }
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.institutionType,
        callback: function ($$v) {
          _vm.$set(item, "institutionType", $$v);
        },
        expression: "item.institutionType"
      }
    }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-text-field', _vm._b({
      attrs: {
        "label": "학교"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.institutionName,
        callback: function ($$v) {
          _vm.$set(item, "institutionName", $$v);
        },
        expression: "item.institutionName"
      }
    }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-text-field', _vm._b({
      attrs: {
        "label": "계열/학과"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.institutionDist,
        callback: function ($$v) {
          _vm.$set(item, "institutionDist", $$v);
        },
        expression: "item.institutionDist"
      }
    }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-select', _vm._b({
      class: `attendingStatus-${_vm.className}-${index}`,
      attrs: {
        "label": "상태",
        "items": _vm.statuses,
        "menuProps": {
          attach: `.attendingStatus-${_vm.className}-${index}`
        }
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.attendingStatus,
        callback: function ($$v) {
          _vm.$set(item, "attendingStatus", $$v);
        },
        expression: "item.attendingStatus"
      }
    }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-date-field', _vm._b({
      attrs: {
        "label": "입학일"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.attendingStartsAt,
        callback: function ($$v) {
          _vm.$set(item, "attendingStartsAt", $$v);
        },
        expression: "item.attendingStartsAt"
      }
    }, 'v-date-field', _vm.attrs_input, false))], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-date-field', _vm._b({
      attrs: {
        "label": "졸업일"
      },
      on: {
        "input": _vm.emit
      },
      model: {
        value: item.attendingEndsAt,
        callback: function ($$v) {
          _vm.$set(item, "attendingEndsAt", $$v);
        },
        expression: "item.attendingEndsAt"
      }
    }, 'v-date-field', _vm.attrs_input, false))], 1)], 1)], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      staticClass: "u-pink ml-auto ml-lg-0",
      attrs: {
        "icon": "",
        "x-small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.remove(item);
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])], 1)], 1)] : [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "4"
      }
    }, [_vm._v(_vm._s(_vm.makeEducationText(item)) + " ")])], 1)]], 2)];
  })], 2), _vm.mode == 'form' ? [_c('v-btn', {
    staticClass: "v-btn--plus rounded-lg",
    attrs: {
      "block": "",
      "color": "grey-f8"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('i', {
    staticClass: "icon icon-plus-sm"
  })])] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }